"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

var Truck = function Truck(props, ref) {
  return (0, _core.jsx)("svg", (0, _extends2["default"])({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), (0, _core.jsx)("path", {
    fill: "currentColor",
    d: "M18.25 13.25h-.256l.118.866c.092.672.138 1.35.138 2.027v1.17c0 .517-.42.937-.938.937H6.688a.937.937 0 01-.937-.938v-1.169c0-.678.046-1.355.138-2.027l.118-.866H5.75a.625.625 0 01-.625-.625V10.75c0-.345.28-.625.625-.625h.682l.071-.524A1.562 1.562 0 018.051 8.25h7.898c.781 0 1.442.577 1.548 1.351l.071.524h.682c.345 0 .625.28.625.625v1.875c0 .345-.28.625-.625.625zm-2.188 3.125a.937.937 0 100-1.875.937.937 0 000 1.875zm-5.938 0c0 .345.28.625.625.625h2.5c.346 0 .625-.28.625-.625v-1.25a.625.625 0 00-.625-.625h-2.5a.625.625 0 00-.625.625v1.25zm-2.187 0a.937.937 0 100-1.875.937.937 0 000 1.875zm8.321-6.605a.313.313 0 00-.31-.27H8.052a.313.313 0 00-.31.27l-.425 3.125a.312.312 0 00.31.355h8.749a.313.313 0 00.31-.355l-.427-3.125zm.714-1.887a2.159 2.159 0 00-1.023-.258H8.05c-.357 0-.708.089-1.023.258a.443.443 0 01-.653-.39V5.125c0-.69.56-1.25 1.25-1.25h8.75c.69 0 1.25.56 1.25 1.25v2.368a.443.443 0 01-.653.39zM6.687 18.875h1.875c.173 0 .313.14.313.313v.312c0 .345-.28.625-.625.625H7a.625.625 0 01-.625-.625v-.313c0-.172.14-.312.313-.312zm8.75 0h1.876c.172 0 .312.14.312.313v.312c0 .345-.28.625-.625.625h-1.25a.625.625 0 01-.625-.625v-.313c0-.172.14-.312.313-.312z"
  }));
};

var _default = (0, _react.forwardRef)(Truck);

var _default2 = _default;
exports["default"] = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"] : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(Truck, "Truck", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icons/Truck.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icons/Truck.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();